//Importaciones
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { ActionButton, ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import { useState } from 'react';
import Message from '../../../../Common/Message';
import SidePanelAddAction from './SidePanelAddAction';
import PropTypes from 'prop-types';
import ToolBarDownFall from '../../../sBook/ToolbarDownFall';
import SidePanelViewAllAction from './SidePanelViewAllAction';
import { useBoolean } from '@fluentui/react-hooks';
import DialogUsedCauseWarning from './DialogUsedCauseWarning';

import './style.css'
import { saveCausesByGapId } from '../../../../../services/sKPI/gap.service';
import GapActionCard from '../GapActionCard/GapActionCard';
import FishboneChart from './FishboneChart';
import { useContext } from 'react';
import GapAppContext from '../../../../../GapAppContext';
import MainAppContext from '../../../../../MainAppContext';
import SidePanelFishboneSelection from '../BusinessElementCard/SidePanelFishboneSelection';
import { useGetListGapCausesBoard } from '../../../../../hooks/services/sKPI/useOfGAP';
import { useEffect } from 'react';
import NoDataLayer from '../../../../Common/NoDataLayer';
import { _checkSecurityUser } from '../../../../../common/Helpers/HLP_Security';
import { __enum_PageMode, enum__PRIVILEGES } from '../../../../../common/Dictionaries';

function Fishbone(props) {
    //Helpers
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);

    //Parametros de componente.
    
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevision = null,
        inputParam_RevisionDataserie = null,
        inputParam_FishboneIndex = null,
        inputParam_HasFishbone = false,
        inputParam_DataserieValueChartSelected = null,
        inputParam_CauseList = null,
        inputParam_SetterCauseList = null,
    } = props;

    const _priv_canSelectFishbone = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_RevisionDataserie !== null ? inputParam_RevisionDataserie.elementId : 0, enum__PRIVILEGES.GAP_CONTRACT_PROPOSE)
    const _priv_canProcessCauses = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_RevisionDataserie !== null ? inputParam_RevisionDataserie.elementId : 0, enum__PRIVILEGES.GAP_CONTRACT_PROPOSE)
    const _priv_canCrudActions = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_RevisionDataserie !== null ? inputParam_RevisionDataserie.elementId : 0, enum__PRIVILEGES.GAP_CONTRACT_PROPOSE)

    const [isActionPanelOpen, setIsActionPanelOpen] = useState(false);
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [isViewAllActionPanelOpen, setIsViewAllActionPanelOpen] = useState(false);
    const [causeIdToAddAction, setCauseIdToAddAction] = useState(null);
    const [causeNameToAddAction, setCauseNameToAddAction] = useState(null);


    const [selectedCauses, setSelectedCauses] = useState(inputParam_CauseList.data === null ? inputParam_RevisionDataserie.l_causes : inputParam_CauseList.data);
    

    useEffect(()=> {
        try {
            if (inputParam_CauseList.fireSearch === false) {
                if (inputParam_CauseList.data === null) {
                    setSelectedCauses(inputParam_RevisionDataserie.l_causes)
                }
                else {
                    setSelectedCauses(inputParam_CauseList.data)
                }
            }
        }
        catch (error) {
        }
    }, [inputParam_CauseList, inputParam_RevisionDataserie]);

    
    const [auxSelectedCauses, setAuxSelectedCauses] = useState(null);
    const [isFishboneSelectionPanelOpen, setIsFishboneSelectionPanelOpen] = useState(false);

    useGetListGapCausesBoard(inputParam_GapAnalyzeId, inputParam_RevisionDataserie.elementId, inputParam_DataserieValueChartSelected ? inputParam_DataserieValueChartSelected.id : null, inputParam_CauseList, inputParam_SetterCauseList)

    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const onOpenFishboneSelectionPanel = (e, id) => {
        setIsFishboneSelectionPanelOpen(true)
    };
    const onReplaceCausesResponse = (replace) => {
        if (replace) {
            saveCausesByGapId(inputParam_GapAnalyzeId, inputParam_RevisionDataserie.elementId, inputParam_RevisionDataserie.dataserieId, inputParam_GapRevision !== null ? inputParam_GapRevision.id : null, inputParam_DataserieValueChartSelected ? inputParam_DataserieValueChartSelected.id : null , auxSelectedCauses).then((response) => {
                if (response.data.succeeded) {
                    //[##] Aqui revisa. Debes o anexar las causas seleccionadas al objeto correcto o de lo contrario blanquear fishbone y revisiondatalist. (esta en contexto nuevo y como propiedad setter.)
                    response.data.data.forEach(cause => {
                        cause.name = inputParam_RevisionDataserie.l_gap_aef_cause.find(x => x.id === cause.gapAefCauseId).name;
                        cause.gapAefCauseId = inputParam_RevisionDataserie.l_gap_aef_cause.find(x => x.id === cause.gapAefCauseId).id;                        
                    });

                    contextGap.dataserieFullData.value.revisionDataserieFullList.forEach(item => {
                        if (item.gapRevisionId === (inputParam_GapRevision !== null ? inputParam_GapRevision.id : null) && item.gapAnalyzeElementId === inputParam_RevisionDataserie.gapAnalyzeElementId) {
                            item.l_causes = response.data.data
                        }
                    });

                    inputParam_SetterCauseList && inputParam_SetterCauseList({fireSearch: true, data:null})

                    contextGap.dataserieFullData.set(prevState => ({
                        ...prevState,
                        revisionDataserieFullList: contextGap.dataserieFullData.value.revisionDataserieFullList,
                    }));

                    const dataserieExist = contextGap.gapRevisionDataserieList.value.find(x => x.dataserieId === inputParam_RevisionDataserie.dataserieId) !== undefined
                    if (!dataserieExist) {
                        contextGap.gapRevisionDataserieList.set(prevState => ({
                            ...prevState,
                            revisionDataserieFullList:null,
                        }));
                    }

                    
                    contextGap.dataserieFullData.value.revisionDataserieFullList.forEach(dataserie => {
                        dataserie.l_dataserie_vals.forEach(dataserieValue => {
                            if (dataserieValue.id === inputParam_DataserieValueChartSelected.id) {

                                dataserieValue.colorGap = "yellow";

                            }
                        });
                    });
           
                    contextGap.dataserieFullData.set(contextGap.dataserieFullData.value);

                    setShowMessage(true)
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        setShowMessage(false)
        setAuxSelectedCauses(null);

        hideDialog()
    }

    const onHaveSameElements = (list1, list2) => {
        if (list1.length !== list2.length) {
            return false;
        }
        return list1.every(element => list2.includes(element));
    }

    const onProcessSelectedCausesClick = () => {
        let oldCauseList = JSON.parse(JSON.stringify(inputParam_RevisionDataserie.l_causes));
        let minMessageShow = false;
        let changesFound = false;

        let newTemp = []

        if (auxSelectedCauses !== null && auxSelectedCauses.length > 0) {
            for (let index = 0; index < oldCauseList.length; index++) {
                let oldCause = oldCauseList[index];
                let itemNotExist = Array.from(auxSelectedCauses).find( x => parseInt(x.id) === oldCause.gapAefCauseId)
                if (itemNotExist === undefined) {
                    newTemp.push({
                        deactivate: true,
                        gapAefCauseId: oldCause.gapAefCauseId,
                        gapId: inputParam_RevisionDataserie.id,
                        id: oldCause.id,
                        l_action: [],
                        priority: null,
                        rootCause: false,
                        statusId: 0,
                        _text: inputParam_RevisionDataserie.l_gap_aef_cause.find(x => x.id === oldCause.gapAefCauseId).name,
                    })
                }
            }

            for (let index = 0; index < auxSelectedCauses.length; index++) {
                let newCause = inputParam_RevisionDataserie.l_gap_aef_cause.find(x => x.id === auxSelectedCauses[index]);
                newTemp.push({
                    deactivate: false,
                    gapAefCauseId: newCause.id,
                    gapId: inputParam_RevisionDataserie.id,
                    id: 0,
                    l_action: [],
                    priority: null,
                    rootCause: false,
                    statusId: 0,
                    _text: newCause.name,
                })
            }
        }

        if((inputParam_RevisionDataserie.l_causes !== null && inputParam_RevisionDataserie.l_causes.length > 0)) {
            //Existen selecciones previas
            if (newTemp.length > 0) {
                //Existen selecciones actuales
                changesFound = newTemp.filter(x => (x.deactivate === false && x.id === 0) || (x.deactivate === true && x.id !== 0)).length > 0
                if (changesFound) {
                    //Existen modificaciones que hacer.
                    let newItems = newTemp.filter(x => x.deactivate === false && x.id === 0)
                    let deactivateItems = newTemp.filter(x => (x.deactivate === true && x.id !== 0))
                    let haveSameElements = onHaveSameElements(newItems.map(x => x.gapAefCauseId), deactivateItems.map(x => x.gapAefCauseId))
                    if (haveSameElements) {
                        //No existen moficicaciones que hacer.
                        changesFound = false
                    }
                }
                else {
                    //No existen moficicaciones que hacer.
                    changesFound = false
                }
            }
            else {
                //No existen selecciones actuales
                if ((inputParam_RevisionDataserie.l_causes === null || inputParam_RevisionDataserie.l_causes.length === 0)) {
                    //No existen selecciones previas
                    minMessageShow = true
                }
            }
        }
        else {
            changesFound = newTemp.filter(x => (x.deactivate === false && x.id === 0) || (x.deactivate === true && x.id !== 0)).length > 0
            if (changesFound) {
                //Existen modificaciones que hacer.
                let newItems = newTemp.filter(x => x.deactivate === false && x.id === 0)
                let deactivateItems = newTemp.filter(x => (x.deactivate === true && x.id !== 0))
                let haveSameElements = onHaveSameElements(newItems.map(x => x.gapAefCauseId), deactivateItems.map(x => x.gapAefCauseId))
                if (haveSameElements) {
                    //No existen moficicaciones que hacer.
                    changesFound = false
                }
            }
            else {
                //No existen moficicaciones que hacer.
                changesFound = false 

                if ((inputParam_RevisionDataserie.l_causes === null || inputParam_RevisionDataserie.l_causes.length === 0)) {
                    //No existen selecciones previas
                    minMessageShow = true
                }              
            }
        }

        if (minMessageShow === true) {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-nocauseselected'))
        }
        if (changesFound === false && minMessageShow === false) {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-nochangesfound'))
        }

        if (minMessageShow === false && changesFound === true) {
            showDialog()
            setAuxSelectedCauses(newTemp)
        }
    }

    const onOpenActionPanel = (causeId, causeName) => {
        setIsActionPanelOpen(true)
        setCauseIdToAddAction(causeId)
        setCauseNameToAddAction(causeName)
    }

    const onSelectedCauses = (limitExcedded, causes) => {
        setAuxSelectedCauses(causes)
        if (limitExcedded) {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('Solo puede seleccionar un máximo de tres causas.'))
        }
    }

    const onRenderCausesContent = (index, item, i) => {
        return <Accordion.Item key={index} eventKey={index} >
                <Accordion.Header>
                    <b>{item.name}</b>
                </Accordion.Header>
                <Accordion.Body className='px-1 py-0'>
                    <Row>
                        <Col className='px-1'>
                            <div>                         
                                <Card.Body className='border-top p-1'>
                                    <div style={{ height: "200px", position: "relative" }}>
                                        <ScrollablePane styles={{contentContainer:{overflowX: "hidden"}}}>
                                            <div>
                                                {
                                                    item.l_action.map((action, index2) => (
                                                        <GapActionCard
                                                            key={index2 + action.id}
                                                            inputParam_GapElementId={'#1'}
                                                            inputParam_EditMode={false}
                                                            inputParam_ActionItem={action}
                                                            inputParam_ShowSeparatorStyle={true}
                                                            inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                            inputParam_GapRevisionId={inputParam_GapRevision !== null ? inputParam_GapRevision.id : null}
                                                            inputParam_DataserieValueChartSelected={inputParam_DataserieValueChartSelected}
                                                            inputParam_SelectedCauses={selectedCauses}
                                                            inputParam_SetterCauseActionList={setSelectedCauses}
                                                        />
                                                    ))
                                                }
                                            </div>
                                        </ScrollablePane>
                                    </div>
                                </Card.Body>
                            </div>
                        </Col>
                    </Row>
                </Accordion.Body>
        </Accordion.Item>
    }

    const toolBarItems_Actions = {
        items: [
            {
                key: 'openAllActions',
                text: t('data-lang-btn-viewallactions'),
                iconProps: { iconName: 'View' },
                onClick: () => setIsViewAllActionPanelOpen(true),
            },
        ],
    };

    let aux_add_action_dinamyc = selectedCauses !== null ? selectedCauses.map((item, index) => {
        return {
            id: item.id,
            gapAefCauseId: item.gapAefCauseId,
            key: 'openAddActions' + index,
            text: t('data-lang-btn-addaction') + " - " + item.name,
            iconProps: { iconName: 'TaskManager' },
            onClick: () => onOpenActionPanel(item.id, item.name),
        }}
    ).filter(x => (_priv_canCrudActions.value && _priv_canCrudActions.mode === __enum_PageMode.Edit)) : []

    inputParam_RevisionDataserie.fishBone !== null && aux_add_action_dinamyc.forEach(element => {
        if (selectedCauses.find(x => x.gapAefCauseId === element.gapAefCauseId) !== undefined) {
            toolBarItems_Actions.items.push(
                element
            )
        }
    });

    //Render de componente.
    return  <Row className="h-100">
                <Col xl={9} className="px-0 pe-1 h-100">
                    <Card className='h-100'>
                        {
                            inputParam_FishboneIndex === 0 &&
                            <Card.Header className="card-header-compact">
                                <h5><b>{t('data-lang-lbl-fishbone')}</b></h5>
                            </Card.Header>
                        }
                        <Card.Footer className='border-bottom p-0'>
                            <Row>
                                <Col className='my-auto ms-2'>
                                {inputParam_GapRevision && inputParam_GapRevision.title}
                                </Col>
                                <Col className='col-auto my-auto'>
                                    <div style={{position: "absolute", display: "contents", width: "100%"}}>
                                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                                    </div>
                                </Col>
                                {
                                    inputParam_HasFishbone && (_priv_canProcessCauses.value && _priv_canProcessCauses.mode === __enum_PageMode.Edit) &&
                                    <Col className='float-end d-flex col-auto'>
                                        <ActionButton
                                            id='btnProcessSelectedCauses'
                                            disabled={!(inputParam_DataserieValueChartSelected && inputParam_DataserieValueChartSelected.gapResult === true)}
                                            iconProps={{ iconName: 'ServerProcesses' }}
                                            onClick={() => onProcessSelectedCausesClick()}
                                            allowDisabledFocus
                                        >
                                            {t('data-lang-btn-processselection')}
                                        </ActionButton>
                                    </Col>
                                }
                                {
                                    inputParam_RevisionDataserie && inputParam_RevisionDataserie.id && !inputParam_HasFishbone && (_priv_canSelectFishbone.value && _priv_canSelectFishbone.mode === __enum_PageMode.Edit) && 
                                    <Col className='col-auto'>
                                        <div className='board-toolbar d-flex float-end'>
                                            <ActionButton id='btnFishboneType' iconProps={{ iconName: 'Relationship' }} onClick={() => onOpenFishboneSelectionPanel()} allowDisabledFocus >
                                                {t('data-lang-btn-selectfishbone')}
                                            </ActionButton>
                                        </div>
                                    </Col>
                                }
                            </Row>
                        </Card.Footer>
                        <Card.Body className='h-100 p-1 pt-3'>
                            <Row className='h-100'>
                                {
                                    inputParam_RevisionDataserie.fishBone.objNew !== null &&
                                    <Col>
                                        <FishboneChart
                                            data={ inputParam_RevisionDataserie.fishBone.objNew }
                                            selectedCauses={auxSelectedCauses === null ? selectedCauses.map(({ gapAefCauseId }) => gapAefCauseId) : auxSelectedCauses}
                                            onSelectCause={onSelectedCauses}
                                        />
                                    </Col>
                                }
                                {
                                    inputParam_RevisionDataserie.fishBone.objNew === null &&
                                    <NoDataLayer display={ true } />
                                }
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xl={3} className='px-0 pe-1'>
                    <Card className='h-100'>
                        {
                            inputParam_FishboneIndex === 0 &&
                            <Card.Header className="card-header-compact">
                                <h5><b>{t('data-lang-lbl-causes')}</b></h5>
                            </Card.Header>
                        }
                        <Card.Footer className='border-bottom p-0'>
                            <div className='float-end'>
                                <ToolBarDownFall items={ toolBarItems_Actions } display={ true } mainItem={ { iconName: 'More' } } />
                            </div>
                        </Card.Footer>
                        <Card.Body className='h-100'>
                            <Row className='h-100'>
                                <Col className='h-100 px-0 pb-0'>
                                    {
                                        selectedCauses.length !== 0 &&
                                        <ScrollablePane
                                                style={{ maxHeight: "100%", height: "100%"}}
                                                styles={{
                                                    root: { position: "relative" },
                                                    contentContainer:{overflowX: "hidden"}
                                                }}
                                                scrollbarVisibility={ScrollbarVisibility.auto}
                                                scrollContainerFocus={true}
                                            >
                                            <Accordion>
                                                {
                                                    
                                                    selectedCauses.map((item, index) => 
                                                        onRenderCausesContent(index, item)
                                                    )
            
                                                }
                                            </Accordion>
                                        </ScrollablePane>
                                    }
                                    {
                                        selectedCauses.length === 0 &&
                                        <NoDataLayer display={ true } />
                                    }
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                {
                inputParam_GapRevision !== null && causeIdToAddAction !== null &&
                    <SidePanelAddAction
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                        inputParam_GapRevisionId={inputParam_GapRevision.id}
                        inputParam_RevisionDataserie={inputParam_RevisionDataserie}
                        inputParam_CauseName={causeNameToAddAction}
                        inputParam_CauseId={causeIdToAddAction}
                        inputParam_IsPanelOpen={isActionPanelOpen}
                        inputParam_SetterIsPanelOpen={setIsActionPanelOpen}
                        inputParam_EditMode={true}
                    />
                }
                <SidePanelFishboneSelection
                    isPanelOpen={isFishboneSelectionPanelOpen}
                    setterIsPanelOpen={setIsFishboneSelectionPanelOpen}
                    gapId={inputParam_GapAnalyzeId}
                    setterGAPElements={null}
                    elementId={inputParam_RevisionDataserie.id}
                />
                <SidePanelViewAllAction
                    inputParam_EditMode={false}
                    inputParam_IsPanelOpen={isViewAllActionPanelOpen}
                    inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                    inputParam_GapRevisionId={inputParam_GapRevision !== null ? inputParam_GapRevision.id : null}
                    inputParam_SetterIsPanelOpen={setIsViewAllActionPanelOpen}
                />
                <DialogUsedCauseWarning
                    inputParam_IsDialogOpen={isDialogVisible}
                    inputParam_SetterIsDialogOpen={onReplaceCausesResponse}
                    inputParam_SetterDialogClose={hideDialog}
                />  
            </Row>
}

Fishbone.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevision: PropTypes.object,
    inputParam_FishboneIndex: PropTypes.number.isRequired,
    inputParam_HasFishbone: PropTypes.bool.isRequired,
    inputParam_DataserieValueChartSelected: PropTypes.object,

    inputParam_CauseList: PropTypes.object,
    inputParam_DatinputParam_SetterCauseListaserieValueChartSelected: PropTypes.func,
};

export default Fishbone;